import axios from "axios";
import { baseApiUrl, getHttpHeaders, httpRequest } from "./ApiUtils";

const FirstMonthAssessmentApiUrl = `${baseApiUrl}/api/FirstMonthAssessment`;

export async function getFirstMonthAssessmentQuestionsByEmployeeId(employeeId) {
  return await httpRequest(
    fetchFirstMonthAssessmentQuestionsByEmployeeId.bind(this, employeeId)
  );
}

async function fetchFirstMonthAssessmentQuestionsByEmployeeId(employeeId) {
  let config = getHttpHeaders();
  return await axios.get(`${FirstMonthAssessmentApiUrl}/${employeeId}`, config);
}

export async function updateFirstMonthAssessmentResponses(updatedResponse) {
  return await httpRequest(
    putFirstMonthAssessmentResponses.bind(this, updatedResponse)
  );
}

async function putFirstMonthAssessmentResponses(updatedResponse) {
  let config = getHttpHeaders();
  return await axios.put(
    `${FirstMonthAssessmentApiUrl}/UpdateAssessment`,
    updatedResponse,
    config
  );
}
